var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72152 14.0139C8.72152 14.4279 8.38563 14.7638 7.97155 14.7638C7.55747 14.7639 7.2216 14.4279 7.22157 14.0139L7.24102 8.77244L1.98191 8.77244C1.56786 8.77243 1.23196 8.43654 1.23194 8.02246C1.23192 7.60838 1.56784 7.27251 1.98191 7.27248L7.24102 7.27425L7.25929 1.99365C7.25929 1.57959 7.59519 1.24369 8.00927 1.24367C8.42335 1.24365 8.75922 1.57957 8.75924 1.99365L8.7392 7.27425L13.9983 7.27425C14.4124 7.27425 14.7483 7.61015 14.7483 8.02423C14.7483 8.4383 14.4124 8.77418 13.9983 8.7742L8.7392 8.77244L8.72152 14.0139Z",
    fill: "#3F69FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.100d6f6c731589dba000ff8c21beaabb.svg";
export { ForwardRef as ReactComponent };